import NextLink from 'next/link'

const Link = ({ children, href, ...rest }) => {
  return (
    <NextLink {...rest} href={href}>
      {children}
    </NextLink>
  )
}

export default Link
